import React from 'react';
import {cn} from '@/utils';
import {TabSwitcherProps} from './types';

const TabSwitcher: React.FC<TabSwitcherProps> = ({
  tabs,
  activeKey,
  onChange,
  className = '',
  tabClassName = '',
  activeTabClassName = '',
  indicatorClassName = '',
}) => {
  const activeIndex = tabs.findIndex(tab => tab.key === activeKey);

  const renderLabel = (tab: any, isActive: boolean) => {
    if (typeof tab.label === 'function') {
      return tab.label(isActive);
    }
    return tab.label;
  };

  return (
    <div className={cn('rounded bg-card text-t2 flex relative', className)}>
      {/* 滑动的指示器 */}
      <div
        className={cn(
          'absolute top-0 bottom-0 bg-c1 rounded transition-transform duration-300 ease-in-out',
          indicatorClassName,
        )}
        style={{
          width: `${100 / tabs.length}%`,
          transform: `translateX(${activeIndex * 100}%)`,
        }}
      />

      {/* Tab按钮 */}
      {tabs.map(tab => {
        const isActive = activeKey === tab.key;
        const isDisabled = tab.disabled;

        return (
          <button
            key={tab.key}
            className={cn(
              'flex-1 rounded text-center relative z-10 transition-colors duration-200',
              isActive ? 'font-bold text-black' : 'text-t2',
              isDisabled && 'opacity-50 cursor-not-allowed',
              tabClassName,
              tab.className,
              isActive && activeTabClassName,
            )}
            onClick={() => !isDisabled && onChange(tab.key)}
            disabled={isDisabled}>
            {renderLabel(tab, isActive)}
          </button>
        );
      })}
    </div>
  );
};

export default TabSwitcher;
